/* eslint-disable no-param-reassign */

import MaterialAvatar from '@material-ui/core/Avatar'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import Placeholder from '../Placeholder'

const styles = theme => ({
  root: {
    backgroundColor: props => props.backgroundColor,
    '&.x-small': {
      width: '30px',
      height: '30px',
      fontSize: '1rem',
    },
    '&.medium': {
      width: '80px',
      height: '80px',
      fontSize: '1.875rem',
    },
    '&.large': {
      width: '100px',
      height: '100px',
      fontSize: '3.125rem',
    },
    '&.x-large': {
      width: '200px',
      height: '200px',
      fontSize: '6.25rem',
    },
    '&.square': {
      borderRadius: '4px',
    },
    '&.withBorder': {
      border: theme.borders.default,
    },
  },
  hasImage: {
    '&.square': {
      border: '1px solid red',
    },
  },
})

export function getAllInitials(name) {
  const names = name.split(' ')
  let initials = names[0].substring(0, 1).toUpperCase()
  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase()
  } else {
    initials += names[0].substring(1, 2).toUpperCase()
  }
  return initials
}

export function getFirstInitial(name) {
  const firstLetter = name.substring(0, 1)
  if (name.length > 1) {
    return firstLetter
  }
  return null
}

const Avatar = ({
  alt,
  backgroundColor,
  backupImage,
  classes,
  className,
  color,
  defaultImage,
  name,
  shape,
  single,
  size,
  src,
  srcError,
  withBorder,
  ...rest
}) => {
  const brokenImage = event => {
    event.target.src = defaultImage
  }

  let avatarContent

  if (name && single) {
    avatarContent = getFirstInitial(name)
  } else {
    avatarContent = getAllInitials(name)
  }

  return (
    <MaterialAvatar
      alt={name || alt}
      className={cn(classes.root, size, shape, className, {
        withBorder,
      })}
      src={src && src}
      imgProps={{
        onError: brokenImage,
      }}
      {...rest}
    >
      {!src && (name || single) ? avatarContent : <Placeholder variant={defaultImage} color={color} />}
    </MaterialAvatar>
  )
}

Avatar.defaultProps = {
  backupImage: 'generic',
  name: '',
  shape: 'circle',
  single: false,
  size: 'small',
  withBorder: false,
}

const AvatarNewComponent = withStyles(styles)(Avatar)
AvatarNewComponent.displayName = 'Avatar'
export default AvatarNewComponent
